
interface V3IconCursorProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconCursor = ({ stroke = "#2E77FF" }: V3IconCursorProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.8335 3.83398L7.3335 12.1673L8.66683 8.66732L12.1668 7.33398L3.8335 3.83398Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.6665 8.66602L12.1665 12.166" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
